import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    availableLanguages = [
        {
            name: 'PORTUGUESE',
            icon: '/assets/images/flags/portugal-square.png',
            value: 'pt',
            locale: 'pt-PT'
        },
        {
            name: 'SPANISH',
            icon: '/assets/images/flags/espanha-square.png',
            value: 'es',
            locale: 'es-ES'
        },
        {
            name: 'ENGLISH',
            icon: '/assets/images/flags/estados-unidos-square.png',
            value: 'en',
            locale: 'en-US'
        }
    ]

    selectedLanguage$: BehaviorSubject<string>;

    constructor(private _translateService: TranslateService) {
        this.initializeTranslateServiceVariables();

        this.selectedLanguage$ = new BehaviorSubject(_translateService.currentLang);
    }

    changeLanguage(language: string) {
        if (language != this._translateService.currentLang && this._translateService.getLangs().includes(language)) {
            this.selectedLanguage$.next(language);
            this._translateService.use(language);
            this.setLanguageOnlocalStorage(language);
        }
    }

    getLanguageObject(language?: string): any | null {
        return this.availableLanguages.find( (lang) => lang.value == (language ?? this.selectedLanguage));
    }

    get selectedLanguage(): string {
        return this.selectedLanguage$.getValue();
    }

    private initializeTranslateServiceVariables() {
        this._translateService.addLangs(['pt', 'es', 'en']);
        this._translateService.setDefaultLang('pt');

        let portalLanguage = this.getLanguageFromlocalStorage();
        
        this._translateService.use(portalLanguage ?? 'pt');
    }

    private setLanguageOnlocalStorage(language: string) {
        localStorage.setItem('PortalLanguage', language);
    }

    private getLanguageFromlocalStorage(): string | null {
        return localStorage.getItem('PortalLanguage');
    }

    public get locale() {
        return this.getLanguageObject().locale;
    }
}